// V4 Assisting Blocks
//
// This module registers all assisting blocks for V4.
// It first loads V3 blocks (which internally loads V2 and V1) for backward compatibility.
// No V4-specific assisting blocks are needed at this time.

import AssistingBlocksV3 from "../../v3/assistingBlocks";

const AssistingBlocksV4 = function(props) {
    // Register all V3 assisting blocks first (which chains to V2 → V1)
    // This ensures old saved scripts can still find 'rest_params', 'rest_params_v2', etc.
    AssistingBlocksV3(props);

    // Add V4 help functions here

    return null;
};

export default AssistingBlocksV4;
